<div class="lane-management-card">
  <div class="card-header">
    <div class="card-header-text">
      <h2 class="card-title">Way marketplace</h2>
      <p class="card-description">
        Map this location to its Way vendor location ID so staff can look up and redeem Way
        purchases here. Clearing the ID disables Way purchase flows for this location.
      </p>
    </div>
    <mat-chip [ngClass]="wayConfigured ? 'chip-success' : 'chip-secondary'" disableRipple>
      {{ wayConfigured ? 'Configured' : 'Not configured' }}
    </mat-chip>
  </div>

  <form class="way-settings-form" (ngSubmit)="onSaveWaySettings()">
    <div class="form-field">
      <label class="field-label" for="way-vendor-location-id">Way vendor location ID</label>
      <input
        id="way-vendor-location-id"
        type="text"
        class="form-input"
        [class.error]="wayFieldError"
        name="wayVendorLocationId"
        [(ngModel)]="wayVendorLocationId"
        placeholder="e.g. 9298430"
        maxlength="100"
        [disabled]="isSavingWay"
        autocomplete="off"
      />
      <div class="field-hint">Paste the location ID from Way.</div>
      @if (wayFieldError) {
        <div class="error-message">{{ wayFieldError }}</div>
      }
    </div>

    <div class="way-actions">
      <button
        type="button"
        class="secondary-btn"
        (click)="onClearWaySettings()"
        [disabled]="isSavingWay || !wayConfigured"
      >
        Clear
      </button>
      <button type="submit" class="primary-btn" [disabled]="isSavingWay || !wayDirty">
        {{ isSavingWay ? 'Saving…' : 'Save' }}
      </button>
    </div>
  </form>
</div>

<app-package-mappings
  [companyId]="companyId"
  [locationId]="locationId"
  [wayConfigured]="wayConfigured"
>
</app-package-mappings>

<app-confirmation-modal
  [isVisible]="showClearWayConfirmation"
  [data]="clearWayConfirmationData"
  (cancel)="onClearWayCancel()"
  (confirm)="onClearWayConfirm()"
>
</app-confirmation-modal>
